// extracted by mini-css-extract-plugin
export default {"backdrop":"modal_backdrop__Y823W","modal":"modal_modal__kNxZ4","slide-down":"modal_slide-down__9FgWI"};